import { getCookie } from './cookie';
import config from './config';

export const DRFdetailsave = async (DRFdETAIL,leadid,lenderId) => {
    
	const token = getCookie(btoa('token'));
	return await (await fetch(
		`${config.baseUrl.admin}/co-lender/lead/drf/${leadid}/${lenderId}`,
		{
            method: 'POST',
			body: JSON.stringify(DRFdETAIL),
			headers: {
				Authorization: `Bearer ${token}`,
				...config.defaultHeaders
			}
		}
	)).json();
};

export const DRFdetailGet = async (leadid, lenderId) => {
	const token = getCookie(btoa('token'));
	return await (await fetch(`${config.baseUrl.admin}/co-lender/lead/drf/${leadid}/${lenderId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
			...config.defaultHeaders
		}
	})).json();
};

 
